<template>
    <div>
      <h2 class="text-1xl font-bold text-gray-700">
        Mantenimiento proveedores
      </h2>
      <MainSuppliers />
    </div>
  </template>
  
  <script>
  import MainSuppliers from "@/components/Suppliers/MainSuppliers.vue";
import { useRoute } from 'vue-router';
import { onBeforeMount, onMounted } from 'vue';
import { findSubmoduleIdByDescription } from '@/hisAcces';
  export default {
    name: "SettingSuppliers",
    components: {
        MainSuppliers,
    },
  setup() {
    const route = useRoute();
    onBeforeMount(() => {
      if (!findSubmoduleIdByDescription(route.path)) {
        window.location.href = "/login";
      }
    });

    onMounted(() => {
      document.title =
        route.meta.title + process.env.VUE_APP_TITLE ||
        process.env.VUE_APP_TITLE;
    });
  },
  };
  </script>
  